/**
 * Any error triggered by an ARN module.
 */
export class ArnError extends Error {
  constructor(message: string) {
    super(message);
  }
}
